import React from 'react'
import { connect } from "react-redux"
//import {withRouter} from 'react-router'
import * as Auth from '../signin/auth.js'

import { setTitle, fetchPractice, joinPractice, setUser } from "../../actions/index"
import PracticeHeader from './PracticeHeader'
import { withRouter } from 'react-router'
import contactImg from '../../images/icons/contact.svg'
import locationImg from '../../images/icons/location.svg'
import emailImg from '../../images/icons/email.svg'
import Avatar from '../user/Avatar'
import Loader from '../ui/loader/Loader';

import './styles/PracticeYay.scss'




let contactStyle = {
	'backgroundImage': `url('${contactImg}')`,
}

let locationStyle = {
	'backgroundImage': `url('${locationImg}')`,
}

let emailStyle = {
	'backgroundImage': `url('${emailImg}')`,
}


@connect((store) => {
	return {
	practice_types: [...store.practice_types],
    User: store.User,
    app: store.app
  };
})
class Practice extends React.Component {
	constructor(props) {
		super(props);
		this.join = this.join.bind(this)
		this.getPractice = this.getPractice.bind(this);
		this.doRedirectSignin = this.doRedirectSignin.bind(this)
		this.doRedirectSigninLink = this.doRedirectSigninLink.bind(this);
		this.doRedirectGoogleSignin = this.doRedirectGoogleSignin.bind(this);
		this.doRedirectFacebookSignin = this.doRedirectFacebookSignin.bind(this);
		this.joinButton = this.joinButton.bind(this)
		this.goToContact = this.goToContact.bind(this)
		this.goToAbout = this.goToAbout.bind(this)
		this.goToLocation = this.goToLocation.bind(this)
		this.setup = this.setup.bind(this);
	}

	componentDidMount() {
        Auth.getRedirectResult()
    }

	doRedirectGoogleSignin() {
		this.doRedirectSignin('Google')
	}

	doRedirectFacebookSignin() {
		this.doRedirectSignin('Facebook')
	}

	goToContact() {
		const { router, routeParams } = this.props;
		router.push(`/practice/${routeParams.name}/contact`)
	}
	goToAbout() {
		const { router, routeParams } = this.props;
		router.push(`/practice/${routeParams.name}`)
	}
	goToLocation() {
		const { router, routeParams } = this.props;
		router.push(`/practice/${routeParams.name}/location`)
	}

	doRedirectSignin(p) {
		const { routeParams, dispatch } = this.props;
		dispatch({
            type: 'SET_AUTHENTICATING',
            payload: true
        })
		dispatch(setUser({signedInUrl: `practice/${routeParams.name}`}))
		return Auth.doRedirectSignin(p)
			.catch((e) => {
				if (e.code === 'auth/account-exists-with-different-credential') {
					this.refs.signinButtons.style.display = 'none';
					this.refs.signinLinkButton.style.display = 'block';
					return
				}
				if (e) {
					console.log(e)
					alert(`Error with signup ${e.code}
					Message:${e.message}
					`)
					window.location.reload()
				}
			});
	}

	doRedirectSigninLink(p) {
		const { routeParams } = this.props;

		Auth.doRedirectSigninLink(p, `practice/${routeParams.name}`)
	}

	join() {
		const { router, routeParams, app, dispatch } = this.props;
		dispatch(joinPractice(app.practice._id))
		.then(() => {
			router.push(`/yay/practice/${routeParams.name}`);
		})
	}

	joinButton() {
		let { app, User } = this.props;
		if (app.practice.userTypes) {
			return !app.practice.userTypes.pendingUsers && User.User.loggedIn ? <div className="center" >
				<button onClick={this.join} className="md-button md-accent joinPracticeButton">
					Join {app.practice.name}
				</button>
				<br /><br />
			</div>
				: null;
		} else {
			return null;
		}

	}

	getPractice() {
		return this.props.dispatch(
			fetchPractice(this.props.params.name)
		)
	}

	getPracticeType(){
		// console.log(this.props.practice_types)
	}

	componentDidUpdate(nextProps) {
		const { User } = this.props;

		if (User.User.token && User.User.name != nextProps.User.User.name) {
			this.setup();
		}
	}

	componentWillMount() {
		const { User } = this.props;

		if (User.User.token && User.User.name != '') {
			this.setup();
		}
		
	}

	setup() {

		this.props.dispatch(setTitle('SpecialT'));
		this.getPractice()
		this.getPracticeType()
	}

	render() {
		const { app, routeParams, User, practice_types } = this.props;
		let practiceTypeHeader = '';
		// console.log(this.props.app.practice);
		if (practice_types.length > 0 && this.props.app.practice !== undefined && this.props.app.practice !== null ) {
			const foundPracticeType = practice_types.find(({_id}) => {
				if (this.props.app.practice.practice_type !== undefined) {
					return _id === this.props.app.practice.practice_type;
				}
			});
			if (foundPracticeType !== undefined) {
				practiceTypeHeader = foundPracticeType.practice_type;
			}
		}

		return <main className="main practice-page " >
			<PracticeHeader 
				practiceType={practiceTypeHeader}
				practice={this.props.app.practice || { name: '...' }}
				>
				<div onClick={this.goToContact} style={contactStyle}>
					<label>Contact</label>
				</div>
				<div onClick={this.goToAbout} style={emailStyle}>
					<label>About</label>
				</div>
				<div onClick={this.goToLocation} style={locationStyle}>
					<label>Location</label>
				</div>
			</PracticeHeader>
			{this.props.app.practice._id && this.joinButton()}
			<div className="page mb8 padding">
				<br />

				{ app.authenticating && (
					<div>
						<br/><br/>
						<div className="center dark">
							<Loader /><br/>
							<p >Authenticating</p>
						</div>
					</div>
				)}
				<div >
					{(!User.User.loggedIn && this.props.app.authed && !app.authenticating) &&
						<div className="card ">
							<div className="md-subheading card-header padding">Sign in</div>
							<div ref="signinButtons" className="padding" >
								<button onClick={this.doRedirectGoogleSignin} className="signin-button google md-button md-raised ">
									Continue with Google
									</button>
								<button onClick={this.doRedirectFacebookSignin} className="signin-button facebook md-button md-raised ">
									Continue with Facebook
									</button>

							</div>
							<div ref="signinLinkButton" className="signin-link-button">
								<p>
									You have previously signed in with {User.existingProviderName}. Continue to link {User.newProviderName}
									with {User.existingProviderName}.
									</p>
								<button onClick={this.doRedirectSigninLink} className={`signin-button ${this.props.User.existingProviderName.toLowerCase()} mdl-button mdl-js-button mdl-button--raised mdl-js-ripple-effect`}>
									Continue with {User.existingProviderName}
								</button>
							</div>

						</div>
					}
					<br />
					


					{(!routeParams.info && app.practice.description) && app.practice.description
						.split('\n')
						.map((t, i) => <p key={`description-${i}`}>{t}</p>)}

					{routeParams.info === 'contact' && <contact>
						<table className="data border">
							<tr>
								<th colSpan="2"><b>Contacts</b></th>
							</tr>
							<tr>
								<td>Phone</td>
								<td>
									{app.practice.phone}
								</td>
							</tr>
							<tr>
								<td>Mobile</td>
								<td>
									{app.practice.mobile}
								</td>
							</tr>
							<tr>
								<td>Email</td>
								<td>
									<a href={`mailto:${app.practice.email}`}>{app.practice.email}</a>
								</td>
							</tr>
							<tr>
								<td>www</td>
								<td>
									<a href={`http://${app.practice.www}`} target="_new">{app.practice.www}</a>
								</td>
							</tr>
						</table>
					</contact>
					}

					{routeParams.info === 'location' && (
						<table className="data border">
							<tr>
								<th ><b>Location</b></th>
							</tr>
							<tr>
								<td >
									<address>
										{app.practice.address1}<br />
										{app.practice.address2}<br />
										{app.practice.city}<br />
										{app.practice.state}<br />
										{app.practice.postCode}<br />
										{app.practice.country}<br />
									</address>
								</td>
							</tr>
						</table>)

					}

					<br />
				</div>

				<div className="grid auto">
					{app.practice.therapists ? app.practice.therapists
						.map(therapist => {
							return (
								<div className="padding avatar-wrapper" key={`therapist-${therapist._id}`}><Avatar pic={therapist.picture} name={therapist.name} />
									<label className="md-caption">{therapist.name && therapist.name.split(' ')[0]}</label>
								</div>
							)
						}) : null}
				</div>
			</div>
		</main>
	}
}

Practice.defaultProps = {
	app: {
		practice: {
			userTypes: {
				therapists: false,
				parents: false,
				pendingUsers: false,
				owner: false
			}
		}
	}
}

export default withRouter(Practice);



// WEBPACK FOOTER //
// ./src/components/practice/Practice.jsx